import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { toast } from "sonner";
import { Users, MapPin } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { errMsg } from "@/lib/api";
import { DddPicker, useDddCounts } from "./DddPicker";

const BASE = { state: "", city: "", category: "", origin: "", member_ids: [] };
const isAll = (g) => g.everyone && !g.state && !g.city && !g.category && !g.origin && !(g.ddds || []).length;
const sameDdds = (g, ddds) => !g.everyone && !g.state && !g.city && !g.category && !g.origin && !(g.member_ids || []).length
  && (g.ddds || []).join(",") === [...ddds].sort().join(",");

export const QuickSend = ({ groups, onReady }) => {
  const { api } = useOutletContext();
  const [open, setOpen] = useState(false);
  const [ddds, setDdds] = useState([]);
  const [busy, setBusy] = useState(false);
  const rows = useDddCounts(open);
  const ensure = async (match, body) => {
    const found = groups.find(match);
    if (found) return onReady(found.id);
    if (busy) return undefined;
    setBusy(true);
    try { const { data } = await api.post("/admin/groups", { ...BASE, ...body }); onReady(data.id); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
    return undefined;
  };
  const all = () => ensure(isAll, { name: "Todos os participantes", everyone: true, ddds: [] });
  const byDdd = async () => {
    const sorted = [...ddds].sort();
    await ensure((g) => sameDdds(g, sorted), { name: `DDD ${sorted.map((d) => `(${d})`).join(" ")}`, everyone: false, ddds: sorted });
    setOpen(false); setDdds([]);
  };
  const total = rows.filter((r) => ddds.includes(r.ddd)).reduce((s, r) => s + r.count, 0);
  return (
    <div className="flex flex-wrap gap-2">
      <Button data-testid="quick-send-all" onClick={all} disabled={busy} className="h-11 gap-2"><Users className="h-4 w-4" />Enviar para todos</Button>
      <Button data-testid="quick-send-ddd" variant="outline" onClick={() => setOpen(true)} className="h-11 gap-2 border-zap-deep text-zap-deep"><MapPin className="h-4 w-4" />Enviar por DDD</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="quick-ddd-dialog" className="max-h-[90dvh] max-w-lg overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Enviar por DDD</DialogTitle>
            <DialogDescription>Toque nos DDDs que vão receber. Pode escolher mais de um.</DialogDescription>
          </DialogHeader>
          <DddPicker rows={rows} value={ddds} onChange={setDdds} testPrefix="quick-ddd" />
          <Button data-testid="quick-ddd-continue" disabled={!ddds.length || busy} onClick={byDdd} className="h-11">
            {ddds.length ? `Continuar \u2014 ${total} ${total === 1 ? "pessoa" : "pessoas"}` : "Escolha um DDD"}
          </Button>
        </DialogContent>
      </Dialog>
    </div>
  );
};
